import saleForceWebHookInstance from '@/services/saleforce';

export const triggerSignUpSfWebhook = async (email: string) => {
    try {
        await saleForceWebHookInstance.post({
            email: email,
            phone: '',
            activation: 'activation1'
        });
    } catch (error) {
        console.error('Error in SaleForceWebHook:', error);
    }
};
